
import { useNavigate } from "react-router-dom";
import ScrollingComparisonCards from "@/components/ui/scrolling-comparison-cards";

const rows = [
  {
    feature: "Tech Stack",
    gimmefy: "Best blend of the latest AI models, optimised for marketing tasks.",
    chatgpt: "Strong general-purpose AI, but not specialised for marketing workflows.",
    jasper: "Multi-model support, but focused mainly on content automation."
  },
  {
    feature: "Trained for Marketing",
    gimmefy: "End-to-end marketing flow: Research → Plan → Create → Edit → Publish.",
    chatgpt: "Powerful reasoning, but marketing strategy must be manually guided.",
    jasper: "Offers workflows and templates, but strategy depth varies across tasks."
  },
  {
    feature: "Rooted in Brand",
    gimmefy: "Brand Vault automatically applies voice, rules, and visual identity.",
    chatgpt: "Custom GPTs and knowledge files help, but no built-in brand governance.",
    jasper: "Strong Brand Voice features, but limited enforcement across formats."
  },
  {
    feature: "All Content Formats",
    gimmefy: "Copy, visuals, video, research, and workflows in one platform.",
    chatgpt: "Copy and images supported, but no integrated video or multi-format pipeline.",
    jasper: "Copy and images available; no native video suite."
  },
  {
    feature: "Publishing",
    gimmefy: "Native publishing to LinkedIn, Meta, and more.",
    chatgpt: "No publishing; manual copy-paste required.",
    jasper: "No native publishing."
  },
  {
    feature: "Unique Features",
    gimmefy: "Playbooks, Reasoning Mode, Brand Guard, brand kits, visual suite, approvals.",
    chatgpt: "General AI with tools and custom GPTs, but no marketing-specific system.",
    jasper: "Workflows and Brand Voice, but fewer advanced marketing intelligence tools."
  },
  {
    feature: "Workspaces",
    gimmefy: "Team-ready with roles, permissions, approvals, and audit trails.",
    chatgpt: "Team and Enterprise exist, but limited content governance.",
    jasper: "Supports teams, but governance features are lighter."
  },
  {
    feature: "Cost Effective",
    gimmefy: "Complete marketing creation platform under one subscription.",
    chatgpt: "Requires multiple external tools for visuals, video, workflows, and publishing.",
    jasper: "Requires additional tools for video and advanced workflows."
  }
];

export default function ThreeWayComparisonTable() {
  const _navigate = useNavigate();

  return (
    <aside aria-label="Feature comparison" className="w-full max-w-6xl mx-auto">
      <div className="overflow-hidden">
        {/* Desktop/tablet layout */}
        <div className="hidden md:grid grid-cols-[1fr_2.5fr_1.5fr_1.5fr] gap-0">
          {/* Header row */}
          <div className="col-span-1 px-3 py-3 text-sm font-medium text-muted-foreground">
            {/* Empty space instead of Features */}
          </div>
          <div className="col-span-1 px-3 py-3 text-sm md:text-base font-bold text-primary bg-primary/10">
            gimmefy
          </div>
          <div className="col-span-1 px-3 py-3 text-sm md:text-base font-semibold text-foreground">
            ChatGPT
          </div>
          <div className="col-span-1 px-3 py-3 text-sm md:text-base font-semibold text-foreground">
            <div>Jasper</div>
            <div className="text-xs font-normal text-muted-foreground mt-0.5">
              *based on evaluation done on 14/08/25
            </div>
          </div>

          {rows.map((row, _idx) => (
            <div
              key={row.feature}
              className={`contents ${_idx % 2 === 0 ? "bg-muted/40" : "bg-background"}`}
            >
              <div className="px-3 py-3 text-foreground text-sm font-medium">
                {row.feature}
              </div>
              <div className="px-3 py-3 text-foreground text-sm bg-primary/5">
                <span className="leading-tight font-semibold">{row.gimmefy}</span>
              </div>
              <div className="px-3 py-3 text-muted-foreground text-sm">
                <span className="leading-tight">{row.chatgpt}</span>
              </div>
              <div className="px-3 py-3 text-muted-foreground text-sm">
                <span className="leading-tight">{row.jasper}</span>
              </div>
            </div>
          ))}
        </div>


        {/* Mobile layout - Scrolling Cards */}
        <div className="md:hidden">
          <ScrollingComparisonCards rows={rows} />
        </div>
      </div>
    </aside>
  );
}
